
import React, { Suspense, lazy, useEffect } from 'react'
import { Route, Switch } from 'react-router'
import { connect } from 'react-redux'
import Auth from './components/auth'
import CustomLoader from './components/common/loader'
import withLayout from './components/common/base'
import { callGetMe } from './reducers/auth/session'

const LandingPage = lazy(() => import('./components/landingPage'))
const LoginToken = lazy(() => import('./components/login'))
const DirectLogin = lazy(() => import('./components/login/directLogin'))
const LoginError = lazy(() => import('./components/login/error'))
const Home = lazy(() => import('./components/home'))
const NotFound = lazy(() => import('./components/common/notFound'))
const TBD = lazy(() => import('./components/common/tbd'))
const UserInfo = lazy(() => import('./components/userInfo'))
const CreateUser = lazy(() => import('./components/createUser'))

function withLoader(Component) {
  return props => (
    <Suspense fallback={ <CustomLoader /> } >
      <Component {...props} />
    </Suspense>
  )
}

const Routes = (props) => {
  const { authorized, callGetMe } = props
  const { token } = window.sessionStorage

  useEffect(() => {
    if (token) {
      callGetMe()
    }
  }, [])

  return (
    <Switch>
      <Route exact path="/" component={withLayout(withLoader(LandingPage))} />
      <Route exact path="/login/:token" component={withLayout(withLoader(LoginToken))} />
      <Route exact path="/login/error/:code" component={withLayout(withLoader(LoginError))} />
      <Route exact path="/direct-login" component={withLayout(withLoader(DirectLogin))} />
      
      <Auth path="/home" component={withLayout(withLoader(Home))} authorized={authorized} />
      <Auth path="/user-info" component={withLayout(withLoader(UserInfo))} authorized={authorized} />
      <Auth path="/create-user" component={withLayout(withLoader(CreateUser))} authorized={authorized} />
      <Auth path="/tbd" component={withLayout(withLoader(TBD))} authorized={authorized} />

      <Route path='*' exact={true} component={withLayout(withLoader(NotFound))} />
    </Switch>
  )
}

const mapStateToProps = state => ({
  authorized: state.session.authorized,
})

const mapDispatchToProps = dispatch => ({
  callGetMe: () => dispatch(callGetMe()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Routes)
